import { IDashboardMetadata } from '../dashboard-metadata.service';
import {
  LARGE_QUOTE_KPI,
  OPEN_STOCK_ORDERS_KPI,
  SAT_TICKET_COLUMNS,
  TICKET_SORT,
  USER_APPROVAL_COLUMNS
} from './shared-dashboard.config';
import { CustomerDashboardFiltersComponent } from '../filters/customer/customer-dashboard-filters.component';
import { DateType } from '../../../../shared/services/date.util';
import { VALIDATOR_FN_CUSTOMER } from '../dashboard.service';

export const URGENT_DASHBOARD_CONFIG:IDashboardMetadata = {
    title: 'Customer Urgent KPI',
    filterComponent: {
      name: CustomerDashboardFiltersComponent,
      inputs: {
        allowSearchWithoutFilters: true,
        preselectGbdm: false,
        validatorFn: VALIDATOR_FN_CUSTOMER
      }
    },
    mapping: {
      Decurce: 'currency.id',
      Devincl: 'vatIncl.id',
      Desprnm: 'customer.id',
      Cucomid: 'customerCompany.id',
      Lacgrid: 'lamGroup.id',
      Lacomnm: 'lamCompany.id',
      Delamnm: 'lam.id',
      Decounm: 'country.id',
      Gblname: 'gbdm.id',
      Desk: 'gbdmDesk.id'
    },
    fixedFilters: {
      Decurce: 'EUR',
      Devincl: '0'
    },
    reports: [
      {
        id: 43,
        key: 'PASSED_SLA',
        fixedFilters: {
          Declodt_FROM: DateType.ONE_WEEK_AGO,
          Dedate1: null,
          Dedate2: null,
          Destadt: 1,
          Deestim: 0,
          Totsla_diff: '>0',
          Devendo_cart_show: 1,
          Dependi_show: 1
        },
        mapping: {
          Decurce: 'currency.id',
          Desprnm: 'customer.id',
          Decusid: 'customerCompany.id',
          Delamcm: 'lamCompany.id',
          Desk: 'gbdmDesk.id'
        },
        sort: [
          {
            name: 'Totsla_diff',
            direction: 'desc'
          }
        ],
        columns: [
          'Deordnr', //ACSL#
          {
            name: 'Derecdt',
            label: 'Date submitted'
          },
          'Declodt', //Date Closed
          {
            name: 'Totsla_days', //Total expected SLA
            label: 'Expected SLA'
          },
          {
            name: 'Totsla_cycle', //Total real SLA
            label: 'Real SLA'
          },
          {
            name: 'Totsla_diff', //Total Difference SLA
            label: 'Difference'
          },
          'Decloco', //Closed comment
          'Mainpendingstatus', // Main pending reason
          'Desprnm', //Webshop
          'Decounm', //Country
          'Decomnm', //BP
          'Decodnm', //OD
          'Gblname' //GBDM
        ]
      },
      {
        id: 83,
        key: 'PAYMENT_PENDINGS',
        fixedFilters: {
          Decomds_txt: 'Pending - Payment',
          Dewflty: 'PO'
        },
        mapping: {
          Degbdmn: 'gbdm.id',
          Desk: 'gbdmDesk.id'
        },
        columns: [
          'Depeday', // Age
          'Dependt', // Date pending
          'Desprnm', // Customer name
          'Decommt', // Pending comment
          'Payment_status',
          'Deordnr', // ACSL #
          'Decounm', // Country
          'Owlname',// Owner (name)
          'Degbdmn',// GBDM
          'Lacomnm',// LAM company
          'Lalname',// LAM contact
          'Odlname',// OD
          'Owcnyid',// Owner type
          {
            name: 'Decredt',
            label: 'Submit date'
          }
        ]
      },
      {
        browselistCode: 'TICKET',
        key: 'CAT_TICKETS',
        mapping: {
          Shsprnm: 'customer.id',
          Lacgrid: 'lamGroup.id',
          Shlamcm: 'lamCompany.id',
          Shlacom: 'lam.id',
          Shgbdmn: 'gbdm.id',
          Shcounm: 'country.id'
        },
        fixedFilters: {
          Demntty: '@CATALOGUE@'
        },
        columns: SAT_TICKET_COLUMNS,
        sort: TICKET_SORT
      },
      {
        browselistCode: 'TICKET',
        key: 'SAT_TICKETS',
        mapping: {
          Shsprnm: 'customer.id',
          Lacgrid: 'lamGroup.id',
          Shlamcm: 'lamCompany.id',
          Shlacom: 'lam.id',
          Shgbdmn: 'gbdm.id',
          Shcounm: 'country.id'
        },
        fixedFilters: {
          Demntty: '@SAT@'
        },
        columns: [
          'Deagebd', //Age
          'Demndid', //Ticket #
          'Delstbd', // Days last update
          'Shsprnm', // Webshop
          'Shcounm', // Country
          'Shcomnm', // Company
          'Shlname', // Requested by
          'Showlna', // Owner
          'Decount', // Nr of comments
          'Shdescr', // Subject
          'Dereqid', // ACSL #
          'Shgbdmn', // GBDM
          'Shcommt', // Last comment
          'Shlslna', // Author last comment
          'Dewtyds', // Type
          'Decnyds', // Owner type
          'Dfcnyds', // Default owner type
          'Odlname', // OD
          'Decredt_FROM', // Date created
          'Shlamcn', // LAM contact
          'Shlacom', //LAM
          'Shfcomm', // First comment
          'Shmtyds', //Category
          'Deaddco' // Add comment
        ],
        sort: TICKET_SORT
      },
      {
        id: 221,
        key: 'HIGH_PRIORITY_ITEMS',
        comments: ' ',
        fixedFilters: {
          Devipnr: 'FIRST,VIP'
        },
        mapping: {
          Desk: 'gbdmDesk.id'
        }
      },
      {
        id: 32,
        key: 'HIGH_WORKLOAD_ORDERS',
        fixedFilters: {
          Deactio: 3234846615,
          Deworkl_ma: '>30',
          Deworkl: 1
        },
        mapping: {
          Degbdmn: 'gbdm.id',
          Lalamnm: 'lam.id',
          Lalamcm: 'lamCompany.id',
          Desk: 'gbdmDesk.id'
        },
        columns: [
          'Deworkl_ma', //Mails
          'Deworkl_pe', //Pendings
          'Deworkl_ti', //Tickets
          {
            name: 'Dereqid',
            label: 'ACSL #'
          },
          'Detotal', // Total USD
          'Desprnm',// Customer
          {
            name: 'Deorddt',
            label: 'Submit date'
          },
          'Destatu', // Status
          'Depladt',// Date placed
          'Deetadt',// ETA
          'Decounm',// Country
          'Pacomnm',// BP
          'Decodnm',// OD
          'Degbdmn',// GBDM
          'Destaco',// Status comments
          'Deworkl_co',// Ticket comments
          'Decredt',// Creation date
          'Lalamcm',// LAM company
          'Lalamnm'// LAM
        ],
        sort: [
          {
            name: 'Deworkl_ma',
            direction: 'desc'
          }
        ]
      },
      {

        id: 32,
        key: 'LONG_OUTSTANDING_ORDERS',
        fixedFilters: {
          Deactio: 3234846615,
          Decredt_TO: DateType.NINETY_DAYS_AGO,
          Dewflty_ds: 'PO'
        },
        mapping: {
          Degbdmn: 'gbdm.id',
          Lalamnm: 'lam.id',
          Lalamcm: 'lamCompany.id'
        },
        sort: [
          {
            name: 'Age',
            direction: 'desc'
          }
        ]
      },
      {
        id: OPEN_STOCK_ORDERS_KPI.id,
        key: 'OPEN_STOCK_ORDERS', // normal orders
        fixedFilters: {
          ...OPEN_STOCK_ORDERS_KPI.fixedFilters,
          Decomds: '194', // status master stock - product delivered in stock at bp warehouse
          Destoty_ds: 'NO' // stock order type = normal order
        },
        mapping: OPEN_STOCK_ORDERS_KPI.mapping,
        storedReport: OPEN_STOCK_ORDERS_KPI.storedReport
      },
      {
        id: OPEN_STOCK_ORDERS_KPI.id,
        key: 'OPEN_STOCK_ORDERS_STOCK_TYPE', // stock orders
        fixedFilters: {
          ...OPEN_STOCK_ORDERS_KPI.fixedFilters,
          Decomds: '194,67', // status master stock - product delivered in stock at bp warehouse and shipped - received by bp
          Destoty_ds: 'NPP' // stock order type = master stock order
        },
        mapping: OPEN_STOCK_ORDERS_KPI.mapping,
        storedReport: OPEN_STOCK_ORDERS_KPI.storedReport
      },
      {
        browselistCode: 'ORDER_EDIT',
        key: 'LARGE_OPEN_ORDERS',
        fixedFilters: {
          Dewflty_ds: 'PO',
          Islargeorderorquote: 1,
          Deexuns: 1
        },
        mapping: {
          Delamco_ds: 'lam.id',
          Degbdmn: 'gbdm.id',
          Desk: 'gbdmDesk.id'
        },
        columns: [
          'Detotal', //Total USD
          'Decredt', //Creation date
          'Desprnm', //Customer
          'Decounm', //Country
          'Dereqid', //ACSL #
          'Shstaco', //Status comment short
          'Dereqnm', //Requested by
          'Degbdmn', //GBDM
          'Delamco_ds', //LAM
          'Delamnm', //LAM contact
          'Pacomnm', //BP
          'Decodid_ds', //OD
          'Deavail', //Availability
          'Destatu', //Status
          'Destadt', //Status date
          'Deowner', //Owner
          'Veemail' //Local vendor contact email
        ],
        sort: [
          {
            name: 'Detotal',
            direction: 'desc'
          }
        ]
      },
      {
        browselistCode: 'QUOTE_EDIT',
        key: 'LARGE_QUOTES',
        fixedFilters: LARGE_QUOTE_KPI.fixedFilters,
        mapping: {
          Delamco_ds: 'lam.id',
          Degbdmn: 'gbdm.id',
          Desk: 'gbdmDesk.id'
        },
        columns: LARGE_QUOTE_KPI.columns,
        sort: LARGE_QUOTE_KPI.sort
      },
      {
        id: 29,
        key: 'LARGE_UNSUBMITED_ORDERS',
        fixedFilters: {
          Islargeorderorquote: 1,
          Devincl: 1
        },
        mapping: {
          Degbdmn: 'gbdm.id',
          Delamco: 'lam.id',
          Desk: 'gbdmDesk.id'
        },
        columns: [
          'Detotal', //Total USD
          'Decredt', //Creation date
          'Desprnm', //Customer
          'Decounm', //Country
          {
            name: 'Dereqid',
            label: 'ACSL #'
          },
          {
            name: 'Depornr',
            label: 'Custo #'
          },
          'Decommt', //Status comment short
          'Dereqnm', //Requested by
          'Degbdmn', //GBDM
          'Delamco', //LAM
          'Delamnm', //LAM contact
          'Pacomnm', //BP
          'Odlname', //OD
          'Decomds', //Status
          'Deenddt' //Status date
        ],
        sort: [
          {
            name: 'Detotal',
            direction: 'desc'
          }
        ]
      },
      {
        id: 32,
        key: 'LOST_ORDERS',
        fixedFilters: {
          Deactio: 37,
          Decandt_FROM: DateType.ONE_WEEK_AGO,
          Deorddt_FROM: DateType.FIRST_OF_PREVIOUS_YEAR,
          Dewflty_ds: 'PO'
        },
        mapping: {
          Degbdmn: 'gbdm.id',
          Lalamnm: 'lam.id',
          Lalamcm: 'lamCompany.id',
          Desk: 'gbdmDesk.id'
        },
        columns: [
          'Detotal', //Total USD
          'Decredt', //Creation date
          'Desprnm', //Customer
          'Decounm', //Country
          {
            name: 'Dereqid',
            label: 'ACSL #'
          },
          {
            name: 'Depornr',
            label: 'Custo #'
          },
          'Destaco', //Status comment
          'Dereqnm', //Requested by
          'Degbdmn', //GBDM
          'Lalamnm', //LAM
          'Lalname', //LAM contact
          'Pacomnm', //BP
          'Decodnm', //OD
          'Destatu', //Status
          'Destadt', //Status date
          'Deowner' //Owner
        ],
        sort: [
          {
            name: 'Detotal',
            direction: 'desc'
          }
        ]
      },
      {
        id: 32,
        key: 'LOST_QUOTES',
        fixedFilters: {
          Deactio: 37,
          Decandt_FROM: DateType.ONE_WEEK_AGO,
          Dewflty_ds: 'PQ'
        },
        mapping: {
          Degbdmn: 'gbdm.id',
          Lalamnm: 'lam.id',
          Lalamcm: 'lamCompany.id',
          Desk: 'gbdmDesk.id'
        },
        columns: [
          'Detotal', //Total USD
          'Decredt', //Creation date
          'Desprnm', //Customer
          'Decounm', //Country
          {
            name: 'Dereqid',
            label: 'ACSL #'
          },
          {
            name: 'Depornr',
            label: 'Custo #'
          },
          'Destaco', //Status comment
          'Dereqnm', //Requested by
          'Degbdmn', //GBDM
          'Lalamnm', //LAM
          'Lalname', //LAM contact
          'Pacomnm', //BP
          'Decodnm', //OD
          'Destatu', //Status
          'Destadt', //Status date
          'Deowner' //Owner
        ],
        sort: [
          {
            name: 'Detotal',
            direction: 'desc'
          }
        ]
      },
      {
        id: 8,
        key: 'EXPIRED_CUSTOMER_INVOICES',
        fixedFilters: {
          Deexpdt: '>= -5',
          Denonre_ds: 0,
          Deshort: null,
          Depayst_ds: '0,1,7,8',
          Exclude_batch_bill: 1
        },
        mapping: {
          Desprid: 'customer.id',
          Decomnm: 'customerCompany.name',
          Decouid: 'country.id'
        },
        columns: [
          'Paymentterms',
          'Deexpdt',
          'Avg_payment_terms',
          {
            name: 'Dereqid',
            label: 'ACSL #'
          },
          'Deinvid',
          'Deinvdt',
          'Depayst_ds',
          {
            name: 'Decomnm',
            label: 'Company'
          },
          'Decounm',
          'Gblname',
          'Desprnm',
          'Decommt',
          'Depayto',
          'Depaydt',
          'Depaycm'
        ]
      },
      {
        id: 257,
        key: 'USERS_TO_APPROVE',
        comments: 'Users for which no owner could be found',
        fixedFilters: {
          Decrety_ds: 'SIGNUP',
          Destate_ds: 'WAIT_APRVL',
          Decredt_FROM: '01/01/2018',
          Kpi: 'NO_OWNER',
          Dashboard: 'URGENT'
        },
        mapping: {
          Desprid: 'customer.id',
          Decomnm: 'customerCompany.id',
          Decouid: 'country.id'
        },
        columns: USER_APPROVAL_COLUMNS
      },
      {
        id: 37,
        key: 'PROBLEMATIC_FEES',
        comments: 'Orders where ACSL fee is negative or where there is a LAM fee but no ACSL fee',
        fixedFilters: {
          Problemwithacclsfee: '>0',
          Deinvok: 'not',
          Deinvty: null,
          Dereqst: '3234846615',
          Totalfee: null,
          Declodt_FROM: null,
          Declodt_TO: null
        },
        mapping: {
          Delamcm: 'lamCompany.id',
          Degbdmn: 'gbdm.id'
        },
        columns: [
          'Desprnm', //Customer
          'Decounm', //Country
          'Deconti', //Geography
          'Decomnm', //BP
          'Deordnr', //Order #
          'Depornr', //Customer PO#
          'Accharg', //ACSL fee
          'Lacharg', //LAM fee
          'Superlamfee',
          'Supercustofee',
          'Superbpfee',
          'Finderfee',
          'Decredt', //Order date
          'Declodt', //Order closed date
          'Delamcm', //LAM company
          'Delamcn' //LAM contact OEM
        ]
      },
      {
        id: 56,
        key: 'WRONG_INVOICE_ADDRESS',
        mapping: {
          Degbdmn: 'gbdm.id',
          Desk: 'gbdmDesk.id'
        }
      }
    ]
  }
;